import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Uidesign from "../components/portfolio/UI";
import MobileAppUI from "../components/portfolio/MobileScreen";
import WebDevelopmentUI from "../components/portfolio/WebDevelopmentUI";
import { motion } from "framer-motion";

// Consistent Theme Styles
const customStyles = {
    neonGradientText: {
        background: "linear-gradient(90deg, #00F5A0, #00CFFF)",
        WebkitBackgroundClip: "text",
        WebkitTextFillColor: "transparent",
    },
    sectionDivider: {
        background: "linear-gradient(90deg, #00F5A0, #00CFFF)",
    }
};

export default function Portfolio() {
  return (
    <div
      className="min-h-screen text-white flex flex-col relative overflow-hidden"
      style={{ backgroundColor: "#0B0E11" }} // Base theme background
    >
      <Navbar />

      {/* Global Decorative Glows - Inhe fixed rakha hai taaki scrolling par depth mile */}
      <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-[#00CFFF08] rounded-full blur-[140px] -z-0" />
      <div className="absolute top-1/3 -left-20 w-[400px] h-[400px] bg-[#00F5A005] rounded-full blur-[100px] -z-0" />
      <div className="absolute bottom-0 right-0 w-[500px] h-[500px] bg-[#00CFFF05] rounded-full blur-[120px] -z-0" />

      {/* Page Content */}
      <div className="relative z-10 flex flex-col flex-1 px-4 md:px-20 py-24">
        
        {/* ===== Main Heading ===== */}
        <motion.div 
          initial={{ opacity: 0, y: -20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center mb-28"
        >
          <p className="text-sm text-[#00F5A0] font-bold tracking-[0.4em] uppercase mb-4">
            Showcasing Excellence
          </p>
          <h1 className="text-5xl md:text-7xl font-extrabold tracking-tight">
            <span className="text-white">OUR </span>
            <span style={customStyles.neonGradientText}>PORTFOLIO</span>
          </h1>
          
          <div 
            className="mx-auto mt-8 w-24 h-1.5 rounded-full shadow-[0_0_15px_rgba(0,245,160,0.5)]" 
            style={customStyles.sectionDivider} 
          />

          <p className="mt-8 text-white/60 max-w-2xl mx-auto text-lg md:text-xl leading-relaxed font-light">
            A curated selection of interfaces and platforms 
            crafted with <span className="text-white font-semibold italic">precision engineering.</span>
          </p>
        </motion.div>

        {/* ===== Portfolio Sections (Clean Background Integration) ===== */}
        <div className="space-y-60"> {/* Sections ke darmiyan gap thoda badhaya hai for clarity */}
          
          <motion.section 
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true, margin: "-100px" }}
            className="relative"
          >
             <Uidesign />
          </motion.section>

          <motion.section 
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true, margin: "-100px" }}
            className="relative"
          >
             <MobileAppUI />
          </motion.section>

          <motion.section 
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true, margin: "-100px" }}
            className="relative"
          >
             <WebDevelopmentUI />
          </motion.section>
        </div>

        {/* ===== Bottom CTA ===== */}
        <motion.div 
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          className="mt-60 p-12 md:p-20 rounded-[3rem] text-center border border-white/10 bg-white/[0.01] backdrop-blur-2xl relative overflow-hidden group"
          style={{ boxShadow: "0 20px 50px rgba(0,0,0,0.3)" }}
        >
            {/* Subtle Inner Glow */}
            <div className="absolute -bottom-20 -left-20 w-64 h-64 bg-[#00F5A005] rounded-full blur-3xl transition-all group-hover:bg-[#00F5A010]" />
            
            <h3 className="text-4xl md:text-5xl font-bold mb-8">
                Have a <span style={customStyles.neonGradientText}>Unique Idea?</span>
            </h3>
            
            <motion.button 
                whileHover={{ scale: 1.05, boxShadow: "0 20px 40px rgba(0, 245, 160, 0.2)" }}
                whileTap={{ scale: 0.95 }}
                className="px-12 py-5 rounded-full font-black text-black uppercase tracking-widest text-sm transition-all shadow-xl"
                style={{ background: 'linear-gradient(90deg, #00F5A0, #00CFFF)' }}
            >
                Let's Talk →
            </motion.button>
        </motion.div>

      </div>

      <Footer />
    </div>
  );
}